import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=4933df44&scoped=true"
import script from "./goodsList.vue?vue&type=script&lang=js"
export * from "./goodsList.vue?vue&type=script&lang=js"
import style0 from "./goodsList.vue?vue&type=style&index=0&id=4933df44&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4933df44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4933df44')) {
      api.createRecord('4933df44', component.options)
    } else {
      api.reload('4933df44', component.options)
    }
    module.hot.accept("./goodsList.vue?vue&type=template&id=4933df44&scoped=true", function () {
      api.rerender('4933df44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/controlCenter/dialog/goodsList.vue"
export default component.exports